import React from 'react'
import { connect } from 'react-redux'
import styles from './article.module.scss'
import '../../scss/global.scss'
import BackgroundImage from '../../components/BackgroundImage'
import Content from '../../components/Content'
import Image from '../../components/Image'
import Main from '../../components/Main'
import Meta from '../../components/Meta'
import Navigation from '../../components/Navigation'
import NavigationList from '../../components/NavigationList'
import { linkResolver, navResolver } from '../../components/helper'
import * as loaderActions from '../../actions/loader'

class ArticleContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentWillMount() {
    this.props.toggleLoader(true)
  }

  render() {
    const { url, meta_image, meta_title, data } = this.props.data.articleJson
    const {
      content,
      background_image,
      image,
      title,
      home_link,
      navigation,
      pdf,
    } = data
    const homelink = linkResolver(home_link.type, home_link.uid)
    const navitems = navResolver(navigation.type, navigation.uid)
    return [
      <Meta
        key="meta"
        url={url}
        metaTitle={meta_title}
        metaImage={meta_image}
        {...this.props.data.site.siteMetadata}
      />,
      homelink &&
        homelink === '/' && (
          <Navigation key="nav_home" x="left" home={homelink} />
        ),
      homelink &&
        homelink !== '/' && <Navigation key="nav" nav back={homelink} />,
      <NavigationList key="navitems" items={navitems} />,
      <Main key="main">
        <BackgroundImage img={background_image} />
        <Content content={content} title={title} pdf={pdf}>
          <Image img={image} />
        </Content>
      </Main>,
    ]
  }
}

const mapStateToProps = state => {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {
    toggleLoader: loading => {
      dispatch(loaderActions.toggleLoader(loading))
    },
  }
}

const Article = connect(mapStateToProps, mapDispatchToProps)(ArticleContainer)

export default Article

export const query = graphql`
  query ArticlePageQuery($slug: String!) {
    articleJson(fields: { slug: { eq: $slug } }) {
      data {
        title {
          type
          text
        }
        navigation {
          type
          uid
        }
        home_link {
          type
          uid
        }
        url
        pdf {
          link_type
          name
          url
        }
      }
      ...ArticleBgImage
      ...Content
      ...Image
      ...ArticleMeta
    }
    site {
      ...SiteMeta
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/article/index.jsx